import uConnectApi from "../../../api/uconnect/uConnect";

const state = {
  userId: "",
  email: "",
  firstName: "",
  lastName: "",
  abnAcn: "",
  agentRegistrationNumber: "",
  companyName: "",
  businessRegistrationNumber: "",
  countryCode: "",
  mobileNumber: "",
  subscriptionId: "",
  subscriptionType: "",
  subscribedUConnectId: "",
  subscribedUConnectProductCode: "",
  hasVisitedMoreDetails: false,
  couponDetails: null
};

const getters = {};
const mutations = {

  updateUserDetails(state, {user}) {
    console.log("user-state", user);
    state.userId = user.userId;
    state.email = user.email;
    state.firstName = user.firstName;
    state.lastName = user.lastName;
    state.abnAcn = user.abnAcn;
    state.agentRegistrationNumber = user.agentRegistrationNumber;
    state.companyName = user.companyName;
    state.businessRegistrationNumber = user.businessRegistrationNumber;
    state.countryCode = user.countryCode;
    state.mobileNumber = user.mobileNumber;
    state.subscribedUConnectId = user.uconnectSubscriptionId;
  },
  clearUserDetails(state,) {
    state.userId = "";
    state.email = "";
    state.firstName = "";
    state.lastName = "";
    state.abnAcn = "";
    state.agentRegistrationNumber = "";
    state.companyName = "";
    state.businessRegistrationNumber = "";
    state.countryCode = "";
    state.mobileNumber = "";
    state.subscribedUConnectId = "";
    state.couponDetails = null;
  },

  clearCouponDetails(state) {
    state.couponDetails = null;
  },

  updateUserFirstName(state, {firstName}) {
    console.log("firstName", state);
    state.firstName = firstName;
  },
  updateUserLastName(state, {lastName}) {
    console.log("lastName", state);
    state.lastName = lastName;
  },
  updateUserEmail(state, {email}) {
    console.log("email", state);
    state.email = email;
  },
  updateUserId(state, {userId}) {
    state.userId = userId;
  },
  updateContactNumber(state, {contactNumber}) {
    state.countryCode = contactNumber.countryCode;
    state.mobileNumber = contactNumber.phoneNumber;
  },
  updateAbnAcn(state, {abnAcn}) {
    state.abnAcn = abnAcn;
  },
  updateAgentRegistrationNumber(state, {agentRegistrationNumber}) {
    state.agentRegistrationNumber = agentRegistrationNumber;
  },
  updateCompanyName(state, {companyName}) {
    state.companyName = companyName;
  },
  updateBusinessRegistrationNumber(state, {businessRegistrationNumber}) {
    state.businessRegistrationNumber = businessRegistrationNumber;
  },
  updateSubscribedUConnectId(state, {subscribedUConnectId}) {
    state.subscribedUConnectId = subscribedUConnectId;
  },
  updateSubscribedUConnectProductCode(state, {subscribedUConnectProductCode}) {
    state.subscribedUConnectProductCode = subscribedUConnectProductCode;
  },
  setHasVisitedMoreDetails(state, {hasVisited}) {
    state.hasVisitedMoreDetails = hasVisited;
  },
  updateCouponDetails(state, {couponDetails}) {
    state.couponDetails = couponDetails;
  }

};

const actions = {
  checkUConnectUser({state}, {params, callback}) {
    uConnectApi.checkUConnectUserApi({params, callback}, res => {
      callback(res);
    });
  },
  createUConnectUser({state}, {params, callback}) {
    console.log(state);
    uConnectApi.uConnectCreateUserApi({params, callback}, res => {
      callback(res);
    });
  },

  getUConnectSubscribeCheckout({state}, {params, callback}) {
    console.log(state);
    uConnectApi.uConnectSubscribeCheckoutApi({params, callback}, res => {
      callback(res);
    });
  },
  updateUConnectUserSession({state}, {params, callback}) {
    console.log(state);
    uConnectApi.updateUConnectUserSessionApi({params, callback}, res => {
      callback(res);
    });
  },
  getUConnectSubscriptionStatus({state}, {params, callback}) {
    console.log(state);
    uConnectApi.getUConnectSubscriptionStatusApi({params, callback}, res => {
      callback(res);
    });
  },
  getUConnectSubscriptionProducts({state}, {callback}) {
    console.log(state);
    uConnectApi.getUConnectSubscriptionProductsApi({callback}, res => {
      callback(res);
    });
  },
  updateUConnectUserPackageDetails({state}, {params, callback}) {
    console.log(state);
    uConnectApi.updateUConnectUserPackageDetailsApi({params, callback}, res => {
      callback(res);
    });
  },
  updateUConnectUserDetails({state}, {params, callback}) {
    console.log(state);
    uConnectApi.updateUConnectUserDetailsApi({params, callback}, res => {
      callback(res);
    });
  },
  acceptUConnectUserTnc({state}, {params, callback}) {
    console.log(state);
    uConnectApi.updateUConnectUserTncApi({params, callback}, res => {
      callback(res);
    });
  },
  applyCouponCode({state}, {params, callback}) {
    console.log(state);
    uConnectApi.applyCouponCodeApi({params, callback}, res => {
      callback(res);
    });
  },
  releaseCouponCode({state}, {params, callback}) {
    console.log(state);
    uConnectApi.releaseCouponCodeApi({params, callback}, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/uConnect/uConnect.js